import { States } from 'safe'
import {
  SET_EXISTENCES,
  ExistencesTypesOld,
  UPDATE_EXISTENCE,
} from '../actions/actionTypes'
import cloneDeep from 'lodash/cloneDeep'

const initialState: any = {
  existences: {
    stores: [],
    warehouses: [],
  },
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: ExistencesTypesOld
): States.Existence => {
  const _state = { ...state }
  switch (action.type) {
    case SET_EXISTENCES:
      // if (action.payload.type === 'store') {
      //   let i = _state.existences.stores.findIndex(
      //     (s) => s.id === action.payload.id
      //   )
      //   if (i === -1)
      //     _state.existences.stores = [
      //       ..._state.existences.stores,
      //       { id: action.payload.id, items: action.payload.existences },
      //     ]
      //   else _state.existences.stores[i].items = action.payload.existences
      // } else {
      //   let i = _state.existences.warehouses.findIndex(
      //     (w) => w.id === action.payload.id
      //   )
      //   if (i === -1)
      //     _state.existences.warehouses = [
      //       ..._state.existences.warehouses,
      //       { id: action.payload.id, items: action.payload.existences },
      //     ]
      //   else _state.existences.warehouses[i].items = action.payload.existences
      // }
      // _state.existences = _.cloneDeep(_state.existences)
      return _state

    case UPDATE_EXISTENCE:
      let i1
      if (action.payload.typeStorage === 'store') {
        i1 = _state.existences.stores.findIndex(
          (s) => s.id === action.payload.idStorage
        )
        _state.existences.stores[i1].items.forEach((item) => {
          let i = action.payload.existences.findIndex(
            (e) => e.idExistence === item.id
          )
          if (i === -1) return
          item.quantity -= action.payload.existences[i].amount
        })
      } else {
        i1 = _state.existences.warehouses.findIndex(
          (s) => s.id === action.payload.idStorage
        )
        _state.existences.warehouses[i1].items.forEach((item) => {
          let i = action.payload.existences.findIndex(
            (e) => e.idExistence === item.id
          )
          if (i === -1) return
          item.quantity -= action.payload.existences[i].amount
        })
      }
      _state.existences = cloneDeep(_state.existences)
      return _state
    // case SET_EXISTENCE:
    //   return { ...state, existences: [...state.existences, action.payload] };
    default:
      return state
  }
}
